var _rect, _rect2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 20,
    fill: "black",
    fillOpacity: 0.85
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 172,
    height: 172,
    rx: 16,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2646 72.3529L98.5966 48.8235L98.5966 131.176L64.2646 107.647L64.2646 72.3529Z",
    fill: "url(#paint0_linear_1061_6077)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0883 72.353H64.2648V107.647H40.7354V107.647H48.0882L40.7354 100.294L40.7354 79.706L48.0883 72.353Z",
    fill: "url(#paint1_linear_1061_6077)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.042 115.567C113.83 116.958 110.388 117.674 106.912 117.674L106.912 117.674L103.971 120.749L106.912 123.824V123.824C111.161 123.824 115.368 122.949 119.293 121.249C123.218 119.549 126.785 117.058 129.789 113.917C132.793 110.776 135.176 107.047 136.802 102.944C138.428 98.8401 139.265 94.4418 139.265 90C139.265 85.5583 138.428 81.16 136.802 77.0563C135.176 72.9527 132.793 69.224 129.789 66.0832C126.785 62.9424 123.218 60.451 119.293 58.7512C115.368 57.0514 111.161 56.1765 106.912 56.1765V56.1767L103.971 59.2514L106.912 62.3262V62.3262H106.912C110.388 62.3263 113.83 63.0421 117.042 64.4328C120.253 65.8235 123.172 67.862 125.63 70.4317C128.088 73.0015 130.037 76.0522 131.368 79.4097C132.698 82.7673 133.383 86.3659 133.383 90C133.383 93.6342 132.698 97.2328 131.368 100.59C130.037 103.948 128.088 106.999 125.63 109.568C123.172 112.138 120.253 114.177 117.042 115.567ZM106.912 70.8825L103.971 74.0686L106.912 77.2548V77.2549C108.457 77.2549 109.987 77.5846 111.414 78.2251C112.841 78.8656 114.138 79.8044 115.231 80.9879C116.323 82.1714 117.19 83.5764 117.781 85.1227C118.372 86.669 118.677 88.3263 118.677 90C118.677 91.6737 118.372 93.3311 117.781 94.8774C117.19 96.4237 116.323 97.8287 115.231 99.0122C114.138 100.196 112.841 101.134 111.414 101.775C109.987 102.415 108.457 102.745 106.912 102.745L106.912 102.746L103.971 105.932L106.912 109.118V109.118C109.229 109.118 111.524 108.623 113.665 107.662C115.806 106.702 117.752 105.293 119.39 103.518C121.029 101.743 122.329 99.6355 123.216 97.316C124.102 94.9966 124.559 92.5106 124.559 90C124.559 87.4895 124.102 85.0035 123.216 82.684C122.329 80.3646 121.029 78.2571 119.39 76.4818C117.752 74.7066 115.806 73.2984 113.665 72.3376C111.524 71.3769 109.229 70.8824 106.912 70.8824H106.912V70.8825Z",
    fill: "url(#paint2_linear_1061_6077)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1061_6077",
    x1: 98.0882,
    y1: 85.5882,
    x2: 62.7941,
    y2: 85.5882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1061_6077",
    x1: 34.1177,
    y1: 78.2354,
    x2: 62.7942,
    y2: 78.2354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1061_6077",
    x1: 137.794,
    y1: 84.1178,
    x2: 103.971,
    y2: 84.1178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/Volume.9dfa22521dbc1bed89da4f46d5aa4b0e.svg";
export { ForwardRef as ReactComponent };